import { AxiosResponse } from "axios";
import service from "../api/api.services";
import { getAPIURL, getLicenseKey } from "./application.settings";

const api = service()

export const getProductAssignReport = (fromDate: any, toDate: any, lotId: any, countId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.get(getAPIURL() + `getProductAssignReport/${getLicenseKey}/${fromDate}/${toDate}/${lotId}/${countId}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductAssignReport - " + error.message)
            console.log('error caught in service : getProductAssignReport')
        },
    );

export const getDispatchProductReport = (fromDate: any, toDate: any, companyDetailsId: any, lotId: any, countId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.get(getAPIURL() + `getDispatchDetailsReport/${getLicenseKey}/${fromDate}/${toDate}/${companyDetailsId}/${lotId}/${countId}`,
        response => {
            success(response)
        },
        error => {
            failure("getDispatchProductReport - " + error.message)
            console.log('error caught in service : getDispatchProductReport')
        },
    );

export const getProductStockReport = (fromDate: any, toDate: any, lotId: any, countId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.get(getAPIURL() + `getProductStockReport/${getLicenseKey}/${fromDate}/${toDate}/${lotId}/${countId}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductStockReport - " + error.message)
            console.log('error caught in service : getProductStockReport')
        },
    );
